import { render } from "./ReminderSystem.vue?vue&type=template&id=8195702a"
import script from "./ReminderSystem.vue?vue&type=script&lang=js"
export * from "./ReminderSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__